// src/utils/formUtils.js
import { freeEmailDomains } from '../data/freeEmailDomains';
import { carrierDomains } from '../data/carrierDomains';

/**
 * Generates a random 16-character string.
 * @returns {string} A 16-character random string.
 */
export const generateRandom16Characters = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 16; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

/**
 * Validates an email address format.
 * @param {string} email - The email address to validate.
 * @returns {boolean} True if valid, false otherwise.
 */
export const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);


/**
 * Checks if an email is from a carrier domain.
 * @param {string} email - The email address to check.
 * @returns {boolean} True if the email domain is a carrier domain, false otherwise.
 */
export const checkCarrierEmail = (email) => {
  const domain = email.includes('@') ? email.split('@')[1].toLowerCase() : '';
  return carrierDomains.some(carrierDomain => domain.trim() === carrierDomain);
};

/**
 * Checks if an email is from a free or carrier domain.
 * @param {string} email - The email address to check.
 * @returns {boolean} True if the email domain is free or carrier, false otherwise.
 */
export const isFreeOrCarrierDomain = (email) => {
  const domain = email.split('@')[1]?.toLowerCase();
  return freeEmailDomains.includes(domain) || carrierDomains.includes(domain);
};



